/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationUtilizationDefinitionRequest extends models.ScheduleRecommendationDetailsBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationUtilizationDefinitionRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationUtilizationDefinitionRequest>): ScheduleRecommendationUtilizationDefinitionRequest {
        let obj = Object.assign(new ScheduleRecommendationUtilizationDefinitionRequest(), model);
        ScheduleRecommendationUtilizationDefinitionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationUtilizationDefinitionRequest>): ScheduleRecommendationUtilizationDefinitionRequest {
        if (!model) return null;
        return ScheduleRecommendationUtilizationDefinitionRequest.newInstance(<ScheduleRecommendationUtilizationDefinitionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationUtilizationDefinitionRequest) {
        if (!obj) return;

        models.ScheduleRecommendationUtilizationDefinitionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationUtilizationDefinitionRequest): boolean {
        if (models.ScheduleRecommendationDetailsBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationUtilizationDefinitionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
